/* eslint arrow-body-style: 0 */
import ConversationView from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipelines'),
      beforeEnter: (to, from, next) => {
        const { accountId } = to.params;
        const boardId = localStorage.getItem(`selectedboard`) || '1';
        next(frontendURL(`accounts/${accountId}/pipelines/boards/${boardId}`));
      },
      name: 'pipeline',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/pipelines/boards/:board_id'),
      beforeEnter:async (to, from, next) => {
        const { accountId, board_id } = to.params;
        await store.dispatch('pipelines/getBoards');
        const boards = store.getters['pipelines/getAllBoards'];
        const found = boards.some(board => String(board.id) === String(board_id));
        if (found) {
          next();
        } else {
          if(boards.length > 0){
            alert('Board not found and will redirect to Default Board');
            next(frontendURL(`accounts/${accountId}/pipelines/boards/${boards[boards.length -1].id}`));
          }else{
            alert('No board found, create a board first');
            next(frontendURL(`accounts/${accountId}/settings/board`));
          }
        }
      },
      name: 'pipeline_boards',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: (route) => {
        
        return {board_id: route.params.board_id};
      },
    },
  ],
};
